import type { ReferenceDataField } from '@moment/trading-types/instrument-data'

export interface DiversificationField {
  label: string
  value: ReferenceDataField
}
// Fields whose values are calendar years (e.g. 2030), not quantities.
export const CALENDAR_YEAR_FIELD_IDS: ReadonlySet<string> = new Set([
  'maturity_year',
  'workout_year',
])

export const PROPOSAL_FIELD_LABELS: Record<string, string> = {
  type: 'Asset Class',
  municipal_taxable_federal: 'Federally Taxable',
  is_state_tax_applicable: 'State Taxable',
  is_amt_applicable: 'AMT Applicable',
  is_pre_refunded: 'Pre-Refunded',
  treasury_subtype: 'Treasury Type',
  issue_minimum: 'Minimum Denomination',
  has_extraordinary_call: 'Extraordinary Call',

  // CoCo / AT1 fields (CoCo indicator keeps its name via the shared transform)
  coco_event_type: 'Trigger Event Type',
  coco_trigger_type: 'Trigger Type',
  coco_trigger_action: 'Trigger Action',
  coco_trigger_level_type: 'Trigger Level Type',
  coco_trigger_level_value: 'Trigger Level Value',

  // Buy Universe specific fields
  order_price: 'Price',
  order_ytw: 'YTW',
  tax_effective_limit_ytw: 'Tax-Equivalent YTW',
  fixed_transaction_cost_in_yield: 'Transaction Cost in Yield',
  fixed_transaction_cost_in_price: 'Transaction Cost in Price',
  below_de_minimis_threshold: 'Below de minimis threshold',
  de_minimis_threshold_distance: 'De minimis threshold difference',

  fdic_code: 'FDIC Issuer',
}

export const DEFAULT_FEDERAL_TAX_RATE = 0.24

export const STATE_TAX_RATES: Record<string, number> = {
  AL: 0.05,
  AK: 0.0,
  AZ: 0.025,
  AR: 0.039,
  CA: 0.133,
  CO: 0.044,
  CT: 0.0699,
  DE: 0.066,
  FL: 0.0,
  GA: 0.0539,
  HI: 0.11,
  ID: 0.05695,
  IL: 0.0495,
  IN: 0.03,
  IA: 0.038,
  KS: 0.0558,
  KY: 0.04,
  LA: 0.03,
  ME: 0.0715,
  MD: 0.0575,
  MA: 0.09,
  MI: 0.0425,
  MN: 0.0985,
  MS: 0.044,
  MO: 0.047,
  MT: 0.059,
  NE: 0.052,
  NV: 0.0,
  NH: 0.0,
  NJ: 0.1075,
  NM: 0.059,
  NY: 0.109,
  NC: 0.0425,
  ND: 0.025,
  OH: 0.035,
  OK: 0.0475,
  OR: 0.099,
  PA: 0.0307,
  RI: 0.0599,
  SC: 0.062,
  SD: 0.0,
  TN: 0.0,
  TX: 0.0,
  UT: 0.0455,
  VT: 0.0875,
  VA: 0.0575,
  WA: 0.0,
  WV: 0.0482,
  WI: 0.0765,
  WY: 0.0,
  DC: 0.1075,
}
